import React, { useState } from 'react'
import {
    AppBar, Toolbar, IconButton, Typography, InputBase, Button, Popper, Avatar,
    Grow, ClickAwayListener, MenuList, MenuItem, Paper, Icon, ListItemText
} from '@material-ui/core';

import { fade, makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import ListItemIcon from '@material-ui/icons/List';
import SyncIcon from '@material-ui/icons/Sync';
import SearchIcon from '@material-ui/icons/Search';
import TagCloud from '../TagCloud/TagCloud';
import FilterMenu from './FilterMenu';
import { useSelector } from '../../store';
import './TitleBar.scss';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
		tags:{
			height:'30px',
			width:'100%'
		},
		middle:{
			flexGrow: 1,
		},
    search: {
			
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            // width: '50ch',
						width: '100%',
            '&:focus': {
                // width: '20ch',
								width: '100%',
            },
        },
    },
}));





/**
 * 
 * @param onUpdate function onUpdate:{payload[]}=>item[]} 
 * @returns 
 */
function MyTitleBar({ onUpdate,  onQuery, onTagClick, onLogout }) {
    const classes = useStyles();
    
		const isAdmin = useSelector(state => state.isAdmin);
		const items = useSelector(state => state.items);
		const cloudObject = useSelector(state => state.cloud);
		const query = useSelector(state => state.query);

		const [accMenu, setAccMenu] = useState()
		const [q, setQ] = useState(query.q)

    const handleMenuOpen = ev => {
        setAccMenu(ev.currentTarget)
        // this.setState({ anchorAccountMenu: ev.currentTarget });
    }

    const handleMenuClose = ev => {
        setAccMenu(null)
        // this.setState({ anchorAccountMenu: null });
    }

    const handleLogout = ev => {
        // console.log(`ev.currentTarget`, ev.currentTarget)
				onLogout()
    }

		const handleKeyDown = (event) => {
			if (event.key === 'Enter') {
				// 👇 Get input value
				onQuery({...query,q});
			}
		};

		const menuGotoUrl = siteUrl => ev => {
        window.location.href=siteUrl
    }

		const title = (query?.tags?.length>0)?query.tags.map(tag=>{
			return tag.charAt(0).toUpperCase() + tag.slice(1);
		}).join(','):'Galeria';
    return (
        <AppBar className="titlebar" color="default" position="sticky">
            <Toolbar>
                {/* <IconButton
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    aria-label="open drawer"
                >
                    <MenuIcon />
                </IconButton> */}
                <Typography className={classes.title} variant="h6" noWrap>
									{title}
								</Typography>
                <div className={classes.middle}>
									{/* {title} */}
									{/* <small>{JSON.stringify(query)}</small> */}
									{/* {isAdmin?<small> admin</small>:''} */}
								</div>
								<div className={classes.search}>
                    <div className={classes.searchIcon}>
                        <SearchIcon />
                    </div>
										{/* <input 
											type='text' 
											className='SearchBox'
											value={q}
											onChange={e => setQ(e.target.value)}
											onKeyDown={handleKeyDown}
											placeholder="Search…"
											
										/>  */}
                    <InputBase
                        value={q}
                        onChange={e => setQ(e.target.value)}
												onKeyDown={handleKeyDown}
                        placeholder="Search…"
                        classes={{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        }}
                        inputProps={{ 'aria-label': 'search' }}
                    />
                </div>

                {<Button onClick={handleMenuOpen}>
                    {/* <span className={classes.nameInButton}>{`${'yomama'}`}</span> */}
                    <Avatar className={classes.avatar}>{'G'}</Avatar>
                </Button>}

                {<Popper open={!!accMenu} anchorEl={accMenu}
                    transition disablePortal>{({ TransitionProps }) => (
                        <Grow {...TransitionProps} id="menu-item-grow"
                            style={{ transformOrigin: 'center top' }}
                        ><Paper><ClickAwayListener onClickAway={handleMenuClose}>
														
                            <MenuList>
														<li>
														<FilterMenu onUpdate={onUpdate} isAdmin={isAdmin} onQuery={onQuery}/>	
                            </li>
														    {/* <MenuItem onClick={handleSync}>
                                    <ListItemIcon >
                                        <SyncIcon />
                                    </ListItemIcon>
                                    <ListItemText inset primary="Sync" />
                                </MenuItem> */}
                                {/* <MenuItem onClick={handleDownloadModel}>
                                    <ListItemIcon >
                                        <SyncIcon />
                                    </ListItemIcon>
                                    <ListItemText inset primary="Download model" />
                                </MenuItem>
                                <MenuItem onClick={menuGotoUrl("/profile/edit")}>
                                    <ListItemIcon className={classes.menuIcon}>
                                        <Icon className="far fa-fw fa-user" />
                                    </ListItemIcon>
                                    <ListItemText inset primary="Profile" />
                                </MenuItem> */}

                                <MenuItem onClick={handleLogout}>
                                    <ListItemIcon className={classes.menuIcon}>
                                        <Icon className="fas fa-fw fa-sign-out-alt" />
                                    </ListItemIcon>
                                    <ListItemText inset primary="Logout" />
                                </MenuItem>

                            </MenuList>
                        </ClickAwayListener></Paper></Grow>
                    )}</Popper>}
            </Toolbar>
						<div className={classes.tags}>
							<TagCloud query={query} cloudObject={cloudObject} items={items} showCounts={false} onClick={onTagClick}/>
						</div>
        </AppBar>

    )
}


// function OldTitleBar({ query, onQuery }) {
//     const classes = useStyles();
//     return (

//         <AppBar position="sticky">
//             <Toolbar>
//                 <IconButton
//                     edge="start"
//                     className={classes.menuButton}
//                     color="inherit"
//                     aria-label="open drawer"
//                 >
//                     <MenuIcon />
//                 </IconButton>
//                 <Typography className={classes.title} variant="h6" noWrap>
//                     Galeria
//       </Typography>
//                 <div className={classes.search}>
//                     <div className={classes.searchIcon}>
//                         <SearchIcon />
//                     </div>
//                     <InputBase
//                         value={query}
//                         onChange={onQuery}
//                         placeholder="Search…"
//                         classes={{
//                             root: classes.inputRoot,
//                             input: classes.inputInput,
//                         }}
//                         inputProps={{ 'aria-label': 'search' }}
//                     />
//                 </div>
//             </Toolbar>
//         </AppBar>

//     )
// }

export default MyTitleBar
